<div style="background-image: url('../../../assets/img/login-backgroud.png'); height: 100vh;">
    <div class="container">
        <div class="row justify-content-center align-items-center min-vh-100">
            <div class="col-12 col-md-6 col-lg-4">
                <div class="card shadow">
                    <div class="card-body">
                        <h3 class="text-center mb-4 color-D20000 ">TOYOTA</h3>
                        <div *ngIf="showGenericLogin" class="d-grid gap-2">
                            <button class="btn color-000000 btn-lg" (click)="toyotaLogin()"><span
                                    class="color-white">TOYOTA ID User Login</span></button>
                            <button class="btn color-000000 btn-lg" (click)="nonToyotaLogin()"><span
                                    class="color-white">NON-TOYOTA ID User Login</span></button>
                        </div>
                        <div *ngIf="!showGenericLogin" class="d-grid gap-2">
                            <form [formGroup]="form">
                                <mat-form-field class="w-100">
                                    <mat-label class="color-676A6E">User Name</mat-label>
                                    <input matInput formControlName="username">
                                    <mat-error
                                        *ngIf="form.get('username')?.hasError('required') && form.get('username')?.touched">
                                        Please enter user name.
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field class="w-100">
                                    <mat-label class="color-676A6E">Password</mat-label>
                                    <input matInput formControlName="password">
                                    <mat-error
                                        *ngIf="form.get('password')?.hasError('required') && form.get('password')?.touched">
                                        Please enter password.
                                    </mat-error>
                                </mat-form-field>
                                <button class="btn color-000000 btn-lg w-100" (click)="toyotaLogin()"><span
                                        class="color-white">Login</span></button>
                                <button class="btn color-000000 btn-lg w-100 mt-2" (click)="backToGenLogin()"><span
                                        class="color-white">Back to home Login</span></button>
                                <p>You must have user ID and password. If you have not previously registered, or
                                    forgotten
                                    your password, contact the system administrator</p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>